import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { LayoutSwitchElement } from "../CustomComponents/LayoutSwitchElement";

@engineComponent(ComponentTypes.DisplayObject)
export class GridElement extends LayoutSwitchElement {
    //******************************************************************************************************************
    //  BET PLACE STATE
    //******************************************************************************************************************

    public static CaseEmpty: string = "EMPTY";
    public static CaseNormal: string = "NORMAL";
    public static CaseWin: string = "WIN";
    public static CaseWinOut: string = "WIN_OUT";
    public static CaseSelected: string = "SELECTED";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/GridElement.ts
 **/